import { render, staticRenderFns } from "./Loyalty.vue?vue&type=template&id=69ca9c52&scoped=true"
import script from "./Loyalty.vue?vue&type=script&lang=js"
export * from "./Loyalty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ca9c52",
  null
  
)

export default component.exports